import { render } from "./ContractStatistics.vue?vue&type=template&id=4497f13a&scoped=true"
import script from "./ContractStatistics.vue?vue&type=script&lang=js"
export * from "./ContractStatistics.vue?vue&type=script&lang=js"

import "./ContractStatistics.vue?vue&type=style&index=0&id=4497f13a&scoped=true&lang=css"

import exportComponent from "/var/www/likvio.se/html-prod/likvio-fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4497f13a"]])

export default __exports__